import { ApplicationSetting } from '@/shared/domain/ApplicationSetting';

export interface GlobalSetting {
  applications: {
    [APPLICATION_SETTING_TYPES.SMALL_BUSINESS]: ApplicationSetting
  },
}
// We should improve this in the future to use APPLICATION_TYPES instead of this
export enum APPLICATION_SETTING_TYPES {
  SMALL_BUSINESS = 'smallBusiness',
}
